import type { ReactElement } from 'react';
import { Alert, Box } from '@mui/material';
import { useAuthStore } from '../auth/authStore';
import type { CurrentUser } from '../api/types/auth';

/** Route-level guard mirroring menu.ts's visibility predicates (Bölüm 5.2). */
export function RequireRole({
  check,
  children,
}: {
  check: (user: CurrentUser | null) => boolean;
  children: ReactElement;
}) {
  const currentUser = useAuthStore((s) => s.currentUser);

  if (!check(currentUser)) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="warning">Bu sayfayı görüntüleme yetkiniz yok.</Alert>
      </Box>
    );
  }
  return children;
}
